import React from "react";
import Typography from "@mui/material/Typography";
import Subheader from "@components/Subheader/Subheader.tsx";
import PageLayout from "@layouts/PageLayout.tsx";
import { useTranslation } from "react-i18next";
import { Outlet, useNavigate } from "react-router-dom";
import { GatepassTypeCardStyled } from "./GatepassRequestContainer.styles";
import { gatepassCardTypes } from "./utils";

const GatepassRequestContainer: React.FC = () => {
  const { t, i18n } = useTranslation();
  const dir = i18n.language === "ar" ? "rtl" : "ltr";
  const navigate = useNavigate();

  return (
    <PageLayout dir={dir}>
      <Subheader
        testId="gatepass-requet-container-subheader"
        subtitle={t("gatepass.request-gatepass")}
        title={t("gatepass.request-gatepass")}
      />
      <div className="px-24">
        <div className="mt-8 mb-8">
          <Typography variant="h6" component="div">
            {t("gatepass.types.description")}
          </Typography>
        </div>
        <div className="flex flex-wrap gap-6">
          {gatepassCardTypes.map(({ type, name, description, icon, path }) => (
            <GatepassTypeCardStyled
              data-testid={`gatepass-type-card-${type}`}
              key={type}
              variant="outlined"
              sx={{ width: 294, paddingX: 3, paddingY: 4, cursor: "pointer" }}
              onClick={() => navigate(path, { state: { fromGatepassSelection: true } })}
            >
              {icon}
              <div className="mt-6 mb-2 font-bold">
                <Typography variant="body1" component="p" sx={{ fontWeight: "bold" }}>
                  {t(name)}
                </Typography>
              </div>
              <Typography variant="caption" component="div">
                {t(description)}
              </Typography>
            </GatepassTypeCardStyled>
          ))}
        </div>
        <Outlet />
      </div>
    </PageLayout>
  );
};

export default GatepassRequestContainer;
